// import React from "react";

// import {
//   Card,
//   CardBody,
//   CardTitle,
//   Row,
//   Col,
//   Table,
//   Button,
//   Input,
// } from "reactstrap";
// import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";

// const EmployeeSummary: React.FC = () => {
//   return (
//     <div className="p-3">
//   <PageHeader
//     title="Employee Summary"
//     buttons={[
//       {
//         label: "Excel",
//         onClick: () => alert("Download Excel"),
//         color: "#43B9B2",
//       },
//       {
//         label: "CSV",
//         onClick: () => alert("Download CSV"),
//         color: "#43B9B2",
//       },
//     ]}
//   />
//       <Card>
//         <CardBody>
//           <div className="d-flex justify-content-between align-items-center mb-3">
//             <CardTitle tag="h5">Summary Report</CardTitle>
//             <div className="d-flex gap-2">
//               <Input type="select" className="me-2">
//                 <option>Month</option>
//                 <option>All</option>
//               </Input>
//               <Input type="select">
//                 <option>Status</option>
//                 <option>All</option>
//               </Input>
//             </div>
//           </div>

//           <div className="text-center mb-4">
//             <h6>Summary Report | March 2025</h6>
//           </div>

//           <Row className="mb-4">
//             <Col md="6">
//               <p>
//                 <strong>Employee Name:</strong>
//               </p>
//               <p>
//                 <strong>Employee Code:</strong>
//               </p>
//               <p>
//                 <strong>Designation:</strong>
//               </p>
//             </Col>
//             <Col md="6">
//               <p>
//                 <strong>State:</strong>
//               </p>
//               <p>
//                 <strong>Head Quarter/Location:</strong>
//               </p>
//               <p>
//                 <strong>Currency:</strong>
//               </p>
//               <div className="d-flex align-items-center">
//                 <strong>Working Status:&nbsp;</strong>
//                 <Button color="success" size="sm" disabled>
//                   Yes
//                 </Button>
//               </div>
//             </Col>
//           </Row>

//           <Table bordered responsive>
//             <thead className="text-center">
//               <tr>
//                 <th>Particulars</th>
//                 <th>Claimed Amount</th>
//                 <th>Total Amount</th>
//                 <th>Change by Approver</th>
//                 <th>Net Payable Amount</th>
//                 <th>Auditor Change Amount</th>
//                 <th>Auditor's Add Amount</th>
//                 <th>Final Payable Amount</th>
//                 <th>Company Card</th>
//               </tr>
//             </thead>
//             <tbody className="text-center">
//               <tr>
//                 <td>Total</td>
//                 <td>0</td>
//                 <td>0</td>
//                 <td>0</td>
//                 <td>0</td>
//                 <td>0</td>
//                 <td>0</td>
//                 <td>0</td>
//                 <td></td>
//               </tr>
//             </tbody>
//           </Table>

//           <div className="mt-3">
//             <strong>Final Payable Amount ()</strong>
//           </div>
//         </CardBody>
//       </Card>
//     </div>
//   );
// };

// export default EmployeeSummary;

import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Input,
  Badge,
} from "reactstrap";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";

const EmployeeSummary: React.FC = () => {
  return (
    <div
      className="p-2"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <PageHeader
        title="Employee Summary"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      <Card className="shadow-sm">
        <CardBody>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <CardTitle tag="h4" className="mb-0">
              Summary Report
            </CardTitle>
            <div className="d-flex gap-2">
              <RoundedDropdown
                options={[]}
                onSelect={(e) => console.log("status", e)}
                defaultLabel="All"
                width="100px"
                isShowHeading
                DropdownHeading="Month"
                headingColor="#2e8dd3"
              />
              <RoundedDropdown
                options={[]}
                onSelect={(e) => console.log("status", e)}
                defaultLabel="All"
                width="100px"
                isShowHeading
                DropdownHeading="Status"
                headingColor="#2e8dd3"
              />
            </div>
          </div>

          {/* Sub Title */}
          <div className="text-center mb-4">
            <h6 className="fw-bold mb-0">Summary Report | March 2025</h6>
          </div>

          {/* Employee Info */}
          <Table borderless responsive className="mb-4">
            <tbody>
              <tr>
                <td className="fw-bold">Employee Name</td>
                <td></td>
                <td className="fw-bold">State</td>
                <td></td>
              </tr>
              <tr>
                <td className="fw-bold">Employee Code</td>
                <td></td>
                <td className="fw-bold">Head Quarter/ Location</td>
                <td></td>
              </tr>
              <tr>
                <td className="fw-bold">Designation</td>
                <td></td>
                <td className="fw-bold">Currency</td>
                <td></td>
              </tr>
              <tr>
                <td className="fw-bold">Working Status</td>
                <td>
                  <Badge color="success" pill>
                    Yes
                  </Badge>
                </td>
              </tr>
            </tbody>
          </Table>

          {/* Amount Table */}
          <Table bordered responsive>
            <thead className="text-center">
              <tr>
                <th>Particulars</th>
                <th>Claimed Amount</th>
                <th>Total Amount</th>
                <th>Change by Approver</th>
                <th>Net Payable Amount</th>
                <th>Auditor Change Amount</th>
                <th>Auditor's Add Amount</th>
                <th>Final Payable Amount</th>
                <th>Company Card</th>
              </tr>
            </thead>
            <tbody className="text-center">
              <tr>
                <td className="fw-bold">Total</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td></td>
              </tr>
            </tbody>
          </Table>

          {/* Final Payable Amount */}
          <div className="mt-3 fw-bold">Final Payable Amount ()</div>
        </CardBody>
      </Card>
    </div>
  );
};

export default EmployeeSummary;
